import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { noWhitespaceValidator } from 'src/app/common-components/validators/no-whitespace.validator';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-change-dnd-status',
    styleUrls: [],
    templateUrl: './change-dnd-status.component.html',
    standalone: false
})
export class ChangeDNDStatusComponent implements FormComponent {
   form: UntypedFormGroup;

   callState$: Observable<CallState>;

   dndStatus: string | null;

   title: string = 'DND Status';

   constructor(
      private fb: UntypedFormBuilder,
      public dialogRef: MatDialogRef<ChangeDNDStatusComponent>,
      public dialogService: LcsDialogService,
      @Inject(MAT_DIALOG_DATA)
      public data: {
         dndStatus: string | null;
      }
   ) {
      this.dndStatus = data.dndStatus;
      this.form = this.fb.group({
         dndStatus: [this.dndStatus, [noWhitespaceValidator(), Validators.maxLength(50)]],
      });
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onConfirm(): void {
      if (this.form.valid) {
         this.dialogRef.close(this.form.value);
      }
   }
}
